// Blog/page content enhancements: product + collection embeds, and table cell labels.
//
// Author usage examples (within the rich-text editor):
//   <span class="blog-embed--product" data-product-handle="my-product-handle"><a href="/products/my-product-handle">View</a></span>
//   <span class="blog-embed--collection" data-collection-handle="summer" data-limit="4"><a href="/collections/summer">Shop</a></span>
//
// A SINGLE PRODUCT renders as a featured block: one bigger horizontal card (image left, title /
// rating / price right) plus a centred Shop Now button. That is the default for
// blog-embed--product. Use blog-embed--product-plain for the old bare square card.
// blog-embed--product-wide is an alias of the default.
//
// A COLLECTION renders as a centred heading, a centred grid of cards, and a "Shop All" button.
//
// This file also replaces the theme's text-only table cell labels with real elements that keep
// the header's <br>. Its styles are injected from CONTENT_CSS below rather than kept in a separate
// stylesheet; the comment there explains why. assets/article-content.css is now orphaned.
//
// IMPORTANT: use a <span> wrapper containing a real child <a href>. A bare <div> does NOT survive a
// round-trip through the article editor, and putting the class on the anchor itself breaks the
// href fallback below (querySelector only matches children).
//
// IMPORTANT: the editor silently strips unrecognized data-* attributes on save, so the handle is
// read from data-* when present and otherwise parsed out of the child <a href>, which is never
// stripped. This is also why the featured rendering hangs off blog-embed--product rather than a
// newer class name.
//
// IMPORTANT: on any fetch/render failure we leave the placeholder's markup alone instead of
// removing it, so the reader still sees the fallback link rather than the embed vanishing.

(function() {
  var HEADING_STYLE = 'text-align:center;margin-bottom:1rem;color:#41a5da;';
  var CTA_WRAP_STYLE = 'text-align:center;margin-top:1rem;';
  var LABEL_CLASS = 'gob-cell-label';

  function escapeHtml(str){
    return String(str == null ? '' : str)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  /* ------------------------------------------------------------------------
     Content styles
     ------------------------------------------------------------------------
     These rules live here, inside the script, rather than in assets/article-content.css.

     Why: the stylesheet was injected from JS at a URL this script had to construct, and there is
     no way for it to know that file's own asset hash. It borrowed this script's ?v=, so editing
     only the CSS left the URL unchanged and browsers kept serving the superseded copy. Dropping
     the ?v= entirely was worse: the CDN pinned that bare URL for hours. Two files, one version
     number — the skew is structural, and it silently shipped a broken fix twice on 2026-08-24.

     One asset, one version. main-article.liquid loads this script through asset_url, so it always
     carries its own correct hash and these rules can never lag behind it.

     A <style> element applies only once this script parses, which is late, so nothing that would
     look wrong unstyled may depend on it. That is why .gob-cell-label is hidden by an inline
     style at injection time, and why its mobile rule below needs !important to beat that.
  ------------------------------------------------------------------------ */

  var CONTENT_CSS = [
    // Dawn's .grid__item is flex-grow:1, so a partial row (2 or 3 cards in a 4-up grid) stretches
    // to fill the width. flex-grow:0 keeps card size; justify-content then centres the short row.
    '.article-collection-list.grid{justify-content:center}',
    '.article-collection-list.grid>.grid__item{flex-grow:0}',

    // Cell labels: hidden everywhere, shown only where base.css hides the real header row.
    '.gob-cell-label{display:none}',
    '@media screen and (max-width:748px){',
    '.rte table:not(.feature-table-table) td>.gob-cell-label,',
    '.article-template__content table:not(.feature-table-table) td>.gob-cell-label',
    '{display:block !important;width:100%;margin:0 0 .5rem;font-weight:bold;line-height:1.25;font-size:1.4rem}',
    '}',

    // No double label. fixTableLabels removes data-label after injecting our element, and base.css
    // hides its pseudo label on cells without that attribute — which is enough on first paint. But
    // theme-main.js re-runs setupGlobalMobileTableHeaders() on resize and writes data-label back
    // unconditionally, so the pseudo label returns and the cell shows its column name twice: once
    // fused ("...Toddler Drink30g serving") from the attribute, once correctly line-broken from
    // our element. Racing that in JS is the wrong shape, whoever runs last wins. Instead: wherever
    // our element exists, the pseudo element stays off, however often the attribute comes back.
    '@media screen and (max-width:748px){',
    '.rte table td:has(>.gob-cell-label)::before,',
    '.article-template__content table td:has(>.gob-cell-label)::before',
    '{display:none !important;content:none !important}',
    '}',

    // Collapsed table of contents. section-blog-post.css gives .article-toc__title a 1.5rem bottom
    // margin, which is right when the panel is open and the list follows it. On mobile the
    // accordion starts closed (main-article.liquid opens it only at >=750px), so that margin sits
    // under the header with nothing after it and stacks on the container's bottom padding. Keyed
    // off [open] rather than a breakpoint, so it is also right when someone collapses it by hand
    // on desktop.
    '#article-toc.article-toc--accordion:not([open])>summary{margin-bottom:0}',

    // Tighter table of contents on mobile: 1rem padding instead of 2rem, and 1.5rem type
    // throughout. section-blog-post.css sets .article-toc__title to 2rem, which is a lot of header
    // for a collapsed strip on a phone; the items inherit body size, so both are pinned here to
    // keep the block one consistent size.
    '@media screen and (max-width:748px){',
    '#article-toc.article-toc{padding:1rem}',
    '#article-toc .article-toc__title{font-size:1.5rem}',
    '#article-toc .article-toc__items,#article-toc .article-toc__link{font-size:1.5rem}',
    '}'
  ].join('');

  function ensureContentStyles(){
    if (document.getElementById('gob-article-content-css')) return;
    var style = document.createElement('style');
    style.id = 'gob-article-content-css';
    style.textContent = CONTENT_CSS;
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------------------
     Table cell labels
     ------------------------------------------------------------------------
     On narrow screens each table cell shows its column name above the value. The theme did that
     with `content: attr(data-label)`, and theme-main.js built the attribute using
     cell.textContent, which drops <br> with no substitute. A header authored as
     "Sprout Organic Toddler Drink<br>30g serving" came through as "...Toddler Drink30g serving"
     with the words fused, and a follow-up .replace(/\s+/g,'\n') put every word on its own line.

     An HTML attribute cannot carry markup, so attr() can never produce a real <br>. The header
     had a real <br>, so the label gets a real <br>: inject an element carrying the header's own
     markup, and drop the data-label attribute. base.css already hides its pseudo element on cells
     without data-label, so the old text version removes itself on first paint; CONTENT_CSS keeps
     it off after theme-main.js writes the attribute back on resize.

     Runs after theme-main.js (registered first), plus once more on a short timer in case script
     order ever changes, since that function sets data-label unconditionally. Idempotent.
  ------------------------------------------------------------------------ */

  // Keeps <br> as a real element, escapes everything else to text. Never injects arbitrary markup.
  function labelHtmlFrom(cell){
    var out = '';
    Array.prototype.forEach.call(cell.childNodes, function(node){
      if (node.nodeType === 3) {
        out += escapeHtml(node.nodeValue);
      } else if (node.nodeType === 1 && node.tagName === 'BR') {
        out += '<br>';
      } else if (node.nodeType === 1) {
        out += escapeHtml(node.textContent || '');
      }
    });
    return out
      .replace(/ /g, ' ')
      .replace(/[ \t\r\n]+/g, ' ')
      .replace(/\s*<br>\s*/g, '<br>')
      .trim();
  }

  function fixTableLabels(){
    // Every rich-text region on the page, not just the first one: the article body is
    // .article-template__content, but FAQ/glossary tables render in their own separate .rte
    // containers and get the same theme-main.js treatment.
    var scopes = document.querySelectorAll('.article-template__content, .rte');
    if (!scopes.length) return;

    var seen = [];
    Array.prototype.forEach.call(scopes, function(scope){
      Array.prototype.forEach.call(scope.querySelectorAll('table'), function(table){
        if (seen.indexOf(table) !== -1) return; // nested .rte inside .article-template__content
        seen.push(table);
        if (table.classList && table.classList.contains('feature-table-table')) return;

        var headers = table.querySelectorAll('thead th');
        if (!headers.length) headers = table.querySelectorAll('tr:first-child th');
        if (!headers.length) return;

        var labels = Array.prototype.map.call(headers, labelHtmlFrom);
        if (!labels.some(function(l){ return l; })) return;

        var rows = table.querySelectorAll('tbody tr');
        if (!rows.length) rows = Array.prototype.slice.call(table.querySelectorAll('tr')).slice(1);

        Array.prototype.forEach.call(rows, function(row){
          Array.prototype.forEach.call(row.querySelectorAll('td'), function(cell, i){
            var html = labels[i];
            if (!html) return;

            var label = cell.querySelector(':scope > .' + LABEL_CLASS);
            if (!label) {
              label = document.createElement('span');
              label.className = LABEL_CLASS;
              label.setAttribute('aria-hidden', 'true');
              // Hidden inline, not by stylesheet, so there is no flash of duplicated header text
              // if the injected CONTENT_CSS has not applied yet. The mobile rule there uses
              // `display: block !important` to win against this.
              label.style.display = 'none';
              cell.insertBefore(label, cell.firstChild);
            }
            if (label.innerHTML !== html) label.innerHTML = html;

            // base.css hides its pseudo label on cells with no data-label, so this retires it.
            if (cell.hasAttribute('data-label')) cell.removeAttribute('data-label');
          });
        });
      });
    });
  }

  function fetchJSON(url) {
    return fetch(url)
      .then(r=>{if(!r.ok) throw new Error('404'); return r.text();})
      .then(text=>{try{return JSON.parse(text);}catch(e){throw new Error('invalid-json');}});
  }

  // Real collection title.
  //
  // NOTE: /collections/{handle}.js does NOT exist in Shopify — only /products/{handle}.js does.
  // This used to fetch that URL, always got a 404, and silently fell back to a title derived from
  // the handle, so every heading read e.g. "Shop Plant Based Vegan Baby Formula" instead of the
  // real "Plant-Based & Vegan Baby Formula". Fixed 2026-08-24 via templates/collection.title.liquid.
  async function fetchCollectionTitle(handle, fallback){
    try {
      const res = await fetch(`/collections/${encodeURIComponent(handle)}?view=title`);
      if (!res.ok) return fallback;
      const text = (await res.text()).trim();
      // Guard: if the view template is ever missing, Shopify returns a full HTML page.
      if (!text || text.length > 200 || text.indexOf('<') !== -1) return fallback;
      return text;
    } catch (e) {
      return fallback;
    }
  }

  // Normalizes price across the two endpoint shapes:
  //  - /products/{handle}.js  -> product.price is an INTEGER in cents
  //  - /collections/{handle}/products.json -> price lives on variants[0].price as a DECIMAL STRING
  function getProductPrice(product){
    if (typeof product.price === 'number') return (product.price / 100).toFixed(2);
    var v = product.variants && product.variants[0];
    if (v && v.price != null) {
      var n = parseFloat(v.price);
      if (!isNaN(n)) return n.toFixed(2);
    }
    return null;
  }

  function buildProductSchema(product){
    var price = getProductPrice(product);
    var url = product.url || (product.handle ? '/products/' + product.handle : undefined);
    var image = product.featured_image
      || (product.images && product.images[0] && (product.images[0].src || product.images[0]))
      || undefined;
    var sku = (product.variants && product.variants[0]) ? product.variants[0].sku : undefined;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

    var schema = {
      "@context":"https://schema.org/",
      "@type":"Product",
      "name":product.title,
      "url":url,
      "image":image,
      "description":product.description || product.title,
      "sku":sku
    };
    if (price !== null) {
      schema.offers = {
        "@type":"Offer",
        "priceCurrency":currency,
        "price":price,
        "availability":"https://schema.org/InStock",
        "url":url
      };
    }
    return schema;
  }

  function injectSchema(obj){
    const script=document.createElement('script');
    script.type='application/ld+json';
    script.textContent=JSON.stringify(obj);
    document.head.appendChild(script);
  }

  // 'card-product-inline' = square card, used for collection-grid tiles and the plain variant.
  // 'card-product-wide'   = horizontal card used by the featured single-product block.
  function fetchCardHtml(handle, view){
    const v = view || 'card-product-inline';
    return fetch(`/products/${encodeURIComponent(handle)}?view=${encodeURIComponent(v)}`).then(r=>r.text());
  }

  function resolveHandle(el, dataKey, pathPrefix) {
    var fromData = el.dataset ? el.dataset[dataKey] : undefined;
    if (fromData) return fromData;
    var link = el.querySelector('a[href]');
    if (!link) return undefined;
    try {
      var path = new URL(link.getAttribute('href'), window.location.origin).pathname;
      var match = path.match(new RegExp('/' + pathPrefix + '/([^/?#]+)'));
      return match ? decodeURIComponent(match[1]) : undefined;
    } catch (e) {
      return undefined;
    }
  }

  function renderProductPlaceholder(el, opts){
    const options = opts || {};
    const featured = options.featured !== false; // featured is the default
    const view = featured ? 'card-product-wide' : 'card-product-inline';
    const handle = resolveHandle(el, 'productHandle', 'products');
    if(!handle) return;
    Promise.all([
      fetchJSON(`/products/${encodeURIComponent(handle)}.js`),
      fetchCardHtml(handle, view)
    ]).then(([product,html])=>{
      if (featured) {
        // No heading above the card: the card already carries the title. Card + centred CTA.
        const url = product.url || ('/products/' + handle);
        const cardHtml = `<div class="article-product-card__card">${html}</div>`;
        const buttonHtml = `<div style="${CTA_WRAP_STYLE}"><a href="${escapeHtml(url)}" class="button button--primary">Shop Now</a></div>`;
        el.outerHTML = `<div class="article-product-card article-product-card--wide">${cardHtml}${buttonHtml}</div>`;
      } else {
        el.outerHTML = `<div class="article-product-card grid__item">${html}</div>`;
      }
      injectSchema(buildProductSchema(product));
    }).catch(()=>{
      // Leave the placeholder's existing fallback link visible instead of deleting it.
    });
  }

  async function renderCollectionPlaceholder(el) {
    const handle = resolveHandle(el, 'collectionHandle', 'collections');
    if (!handle) return;
    const limit = parseInt(el.dataset && el.dataset.limit) || 4;

    try {
      const prodData = await fetchJSON(`/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}`);
      const products = prodData.products ? prodData.products.slice(0, limit) : [];

      const cardHtmlArr = await Promise.all(products.map(p => fetchCardHtml(p.handle, 'card-product-inline')));
      const cardsHtml = cardHtmlArr.map(h => `<div class="grid__item">${h}</div>`).join('');

      const derived = handle.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      const title = await fetchCollectionTitle(handle, derived);

      const headingHtml = `<h3 style="${HEADING_STYLE}">Shop ${escapeHtml(title)}</h3>`;
      const gridHtml = `<div class="article-collection-list grid grid--4-col-desktop grid--2-col-tablet grid--2-col-tablet-down">${cardsHtml}</div>`;
      // Button says just "Shop All": the collection name is already in the heading above.
      const buttonHtml = `<div style="${CTA_WRAP_STYLE}"><a href="/collections/${encodeURIComponent(handle)}" class="button button--primary">Shop All</a></div>`;

      el.outerHTML = `<div class="article-collection-list-wrapper" style="margin:3rem 0;">${headingHtml}${gridHtml}${buttonHtml}</div>`;

      const itemList = {
        "@context":"https://schema.org/",
        "@type":"ItemList",
        "itemListElement": products.map((p,i)=>({"@type":"ListItem","position":i+1,"url":p.url}))
      };
      injectSchema(itemList);
      products.forEach(p=>injectSchema(buildProductSchema(p)));
    } catch(err){
      // Leave the placeholder's existing fallback link visible instead of deleting it.
    }
  }

  function initEmbeds() {
    ensureContentStyles();

    // Featured (default). querySelectorAll dedupes, so an element with both classes renders once.
    document
      .querySelectorAll('.blog-embed--product:not(.blog-embed--product-plain), .blog-embed--product-wide')
      .forEach(function(el){ renderProductPlaceholder(el, { featured: true }); });

    // Opt-out: bare square card, the pre-2026-08-24 behaviour.
    document.querySelectorAll('.blog-embed--product-plain').forEach(function(el){
      renderProductPlaceholder(el, { featured: false });
    });

    document.querySelectorAll('.blog-embed--collection').forEach(renderCollectionPlaceholder);

    // Must run after theme-main.js has written its own text-only labels.
    fixTableLabels();
    setTimeout(fixTableLabels, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmbeds);
  } else {
    // The script loads deferred, late in the document, after DOMContentLoaded has already fired.
    initEmbeds();
  }
})();
